import * as types from '../constants/actionTypes';

const initialState = {
    hasLoggedOut: false,
};

export default function logoutReducer(state = initialState, action) {
    switch (action.type) {
        case types.LOGOUT_SUCCESS:
            return {
                ...state,
                hasLoggedOut: true,
            };
        default:
            return state;
    }
}